/**
 * Shared Google Places address_components parser for the form components.
 * Moved from components/partials/google-place-parser.blade.php — inline blade
 * scripts die under Livewire morphs (morphdom doesn't execute injected script
 * tags), so the parser now ships in the app.js bundle.
 *
 * Google's component types are country-specific and the old per-component
 * parsers only understood the US shape (city = `locality`), which broke
 * foreign addresses: the UK returns `postal_town` (no locality), Japan uses
 * sublocality wards, others surface the city as administrative_area_level_2/3.
 *
 * City fallback chain: locality → postal_town → sublocality_level_1 →
 * sublocality → administrative_area_level_3 → administrative_area_level_2.
 * Street falls back to the first segment of formatted_address when
 * street_number/route are absent (common outside the US).
 */
export default function alvvaParsePlace(place) {
    const components = (place && place.address_components) || [];
    const get = function (type, useShort) {
        const c = components.find(function (c) { return c.types.includes(type); });
        return c ? (useShort ? c.short_name : c.long_name) : '';
    };

    const city = get('locality') || get('postal_town') || get('sublocality_level_1')
        || get('sublocality') || get('administrative_area_level_3') || get('administrative_area_level_2');

    const streetNumber = get('street_number');
    const route = get('route');
    let street = [streetNumber, route].filter(Boolean).join(' ');
    const formatted = (place && place.formatted_address) || '';
    if (!street && formatted) {
        const first = formatted.split(',')[0].trim();
        if (first && first !== city) street = first;
    }

    return {
        street_number: streetNumber,
        route: route,
        street: street,
        city: city,
        state: get('administrative_area_level_1', true),
        state_long: get('administrative_area_level_1'),
        country: get('country'),
        zip: get('postal_code'),
        formatted: formatted,
    };
}
